import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(
    private http: HttpClient,
    private router: Router
  ) { }

  createAccount(body) {
    return this.http.post(environment.URL + '/authen/CreateAccountUser', body);
  }

  checkEmail(email) {
    return this.http.post(environment.URL + '/authen/CheckEmail', { EMAIL: email });
  }
}
